var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.total < 1
    ? _c("div", { staticClass: "endproduktfinder" }, [
        _c("div", { staticClass: "container" }, [
          _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "ce-wrapper" }, [
              _c("p", [
                _vm._v(
                  "\n                        " +
                    _vm._s(_vm.$t("infotext.unavailable")) +
                    "\n                    "
                ),
              ]),
            ]),
          ]),
        ]),
      ])
    : _c(
        "div",
        { staticClass: "endproduktfinder" },
        [
          _c("div", { staticClass: "container" }, [
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "ce-wrapper" }, [
                _vm.$t("intro_headline")
                  ? _c("h3", [_vm._v(_vm._s(_vm.$t("intro_headline")))])
                  : _vm._e(),
                _vm._v(" "),
                _c("p", [
                  _vm._v(
                    "\n                        " +
                      _vm._s(_vm.infotext) +
                      "\n                    "
                  ),
                ]),
                _vm._v(" "),
                _vm.kundenportal
                  ? _c("p", [
                      _vm._v(
                        "\n                        " +
                          _vm._s(_vm.$t("infotext.kundenportal")) +
                          "\n                    "
                      ),
                    ])
                  : _vm._e(),
              ]),
            ]),
          ]),
          _vm._v(" "),
          _c("epf-filter"),
          _vm._v(" "),
          _c("div", { staticClass: "container" }, [
            _c("div", { staticClass: "row" }, [
              _c(
                "div",
                { staticClass: "col-12" },
                [
                  _c(
                    "global-loading-overlay",
                    {
                      attrs: {
                        showLoading: _vm.freeze && _vm.freeze !== "no-overlay",
                      },
                    },
                    [
                      _vm._v(
                        "\n                        " +
                          _vm._s(_vm.$t("results.loading")) +
                          "\n                    "
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c("strong", [
                    _vm._v(
                      _vm._s(_vm.total) +
                        " " +
                        _vm._s(_vm.$t("results.totalResults"))
                    ),
                  ]),
                  _vm._v(" "),
                  _vm.kundenportal
                    ? [
                        _c("kundenportal-product-combos", {
                          attrs: { products: _vm.entities },
                        }),
                      ]
                    : [
                        _vm._l(_vm.entities, function (product, index) {
                          return [
                            _c(
                              "global-product-combo",
                              {
                                attrs: {
                                  product: product,
                                  isFirst: index === 0,
                                  omitDecorColum: _vm.omitDecorColum,
                                  omitStructureColum: _vm.omitStructureColum,
                                  omitProductColum: _vm.omitProductColum,
                                  "omit-application-column":
                                    _vm.omitApplicationColumn,
                                  omitRawboardColum: _vm.omitRawboardColum,
                                },
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "button-wrapper top right spacer--top-none",
                                    attrs: { slot: "actionArea" },
                                    slot: "actionArea",
                                  },
                                  [
                                    _c(
                                      "global-button",
                                      {
                                        staticClass: "button--spread-xs",
                                        class: _vm.isInProductCombo(
                                          product.order_pid
                                        )
                                          ? "disabled  "
                                          : "",
                                        on: {
                                          click: function ($event) {
                                            return _vm.addToProductCombo(
                                              product.order_pid
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _vm._v(
                                          "\n                                        " +
                                            _vm._s(
                                              _vm.$t("results.requestDealer")
                                            ) +
                                            "\n                                    "
                                        ),
                                      ]
                                    ),
                                  ],
                                  1
                                ),
                              ]
                            ),
                          ]
                        }),
                      ],
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "button-wrapper v-center right" },
                    [
                      _vm.total - _vm.entities.length > 0
                        ? [
                            _c("span", { staticClass: "button-label" }, [
                              _vm._v(_vm._s(_vm.entities.length) + " "),
                              _c("span", [
                                _vm._v(_vm._s(_vm.$t("loadMore.of"))),
                              ]),
                              _vm._v(" " + _vm._s(_vm.total) + " "),
                              _c("span", [
                                _vm._v(_vm._s(_vm.$t("loadMore.products"))),
                              ]),
                            ]),
                            _vm._v(" "),
                            _c(
                              "global-button",
                              {
                                class: { "button--loading": _vm.freeze },
                                attrs: { theme: "secondary" },
                                on: { click: _vm.loadMore },
                              },
                              [
                                _vm._v(
                                  "\n                                " +
                                    _vm._s(_vm.$t("loadMore.button")) +
                                    "\n                            "
                                ),
                              ]
                            ),
                          ]
                        : _vm._e(),
                    ],
                    2
                  ),
                ],
                2
              ),
            ]),
          ]),
        ],
        1
      )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }